import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { t } from 'i18next';
import clsx from 'clsx';
import Step from '../../components/step';
import Input from '../../components/input';
import ActionFooter from '../../components/action-footer';
import styles from './index.module.scss';

export default function AddAccount(props) {
  const [initialFocus, setInitialFocus] = useState(false);
  const [inputRef, setInputRef] = useState(undefined);
  const {
    step,
    currentStep,
    disableEmail,
    disablePhone,
    token,
    onBackClick,
    onNextClick,
    tokenIsPhone,
    onInputChange,
    countryCode,
    onCountryCodeClick,
    error,
  } = props;

  if (step !== currentStep && initialFocus) {
    setInitialFocus(false);
  } else if (step == currentStep && !initialFocus && inputRef) {
    setInitialFocus(true);
    setTimeout(() => {
      if (step == currentStep) {
        inputRef && inputRef.focus();
      }
    }, 300);
  }

  let placeholder = t('add-account.placeholder_email_or_phone');
  if (disableEmail) {
    placeholder = t('add-account.placeholder_phone');
  }
  if (disablePhone) {
    placeholder = t('add-account.placeholder_email');
  }
  return (
    <Step className="stepstyles" number={step} current={currentStep}>
      {/* Logo */}
      <MediaQuery minHeight={410}>
        <div className={clsx(styles.logo, 'logo', 'add-account-logo')} />
      </MediaQuery>
      <div className="add-account-container">
        {/* Text */}
        <MediaQuery minHeight={310}>
          <div className={clsx(styles.header1, 'header1', 'add-account-header1')}>{`${t(
            'add-account.text'
          )} `}</div>
          <div className={clsx(styles.header2, 'header2', 'add-account-header2')}>
            {t('add-account.subtext')}
          </div>
        </MediaQuery>

        {/* Login field */}
        <div className={clsx(styles.input, 'input', 'add-account-input')}>
          <Input
            ref={(element) => setInputRef(element)}
            placeholder={placeholder}
            style={{ width: '80%' }}
            value={token}
            leftText={tokenIsPhone && !disablePhone && countryCode}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onNextClick();
              }
            }}
            autoCorrect="off"
            autoCapitalize="none"
            autoComplete={tokenIsPhone && !disablePhone ? 'tel' : 'email'}
            helperText={error}
            onLeftClick={() => onCountryCodeClick && onCountryCodeClick()}
          />
        </div>
      </div>

      {/* Buttons */}
      <ActionFooter
        backText={t('add-account.back_button')}
        nextText={t('add-account.next_button')}
        onNextClick={() => onNextClick()}
        onBackClick={() => onBackClick()}
      />
    </Step>
  );
}
